import CuratedGrid from "./CuratedGrid";

export default CuratedGrid;
